import { useMutation, useQueryClient } from "react-query";
import { useGetUserInfo } from "./useGetUserInfo";
import { openNotification } from "utils/notification";
import { handleClose } from "utils/apiHelpers/handleClose";

interface IDProps {
    closeEndPointUrl: string;
    queryKey: string;
}

export const useClose = ({ closeEndPointUrl, queryKey }: IDProps) => {
    const queryClient = useQueryClient();
    const { mutate } = useMutation(handleClose);
    const { token } = useGetUserInfo();

    const closeData = (id: any, reason: any) => {
        console.log(reason);
        mutate(
            { id, reason, token, closeEndPointUrl },
            {
                onError: (err: any) => {
                    openNotification({
                        title: "Error",
                        state: "error",
                        description: err.response.data.message,
                        duration: 4.5,
                    });
                },
                onSuccess: (res: any) => {
                    openNotification({
                        title: "Success",
                        state: "success",
                        description: "Job Closed Successfully",
                        duration: 4.5,
                    });

                    queryClient.invalidateQueries({ queryKey: [queryKey] });
                },
            }
        );
    };

    return { closeData };
};
